import React from 'react';
import { Box } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// react-markdown no renderiza HTML crudo y sanea los href, así que no hay XSS.
// No añadir rehype-raw: es justo lo que reabriría ese agujero.
// `node` se descarta: react-markdown lo pasa a los componentes propios y React
// avisaría al reenviarlo a un elemento del DOM.
const components = {
  a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" />,
};

const markdownSx = {
  wordBreak: 'break-word',
  '& > :first-of-type': { mt: 0 },
  '& > :last-child': { mb: 0 },
  '& p': { my: 1.25, lineHeight: 1.6 },
  '& h1': { fontSize: '1.5rem', fontWeight: 700, mt: 2.5, mb: 1, color: '#002642' },
  '& h2': { fontSize: '1.25rem', fontWeight: 700, mt: 2.5, mb: 1, color: '#002642' },
  '& h3': { fontSize: '1.05rem', fontWeight: 700, mt: 2, mb: 0.75, color: '#002642' },
  '& ul, & ol': { my: 1.25, pl: 3 },
  '& li': { mb: 0.5, lineHeight: 1.6 },
  '& a': { color: '#00577A', fontWeight: 600 },
  '& strong': { fontWeight: 700 },
  '& blockquote': {
    my: 1.5,
    ml: 0,
    pl: 2,
    borderLeft: '4px solid rgba(0,38,66,0.2)',
    color: 'text.secondary',
  },
  '& code': {
    px: 0.75,
    py: 0.25,
    borderRadius: '4px',
    backgroundColor: 'rgba(0,0,0,0.06)',
    fontFamily: 'monospace',
    fontSize: '0.875em',
  },
  '& pre': {
    my: 1.5,
    p: 1.5,
    borderRadius: '8px',
    backgroundColor: 'rgba(0,0,0,0.06)',
    overflowX: 'auto',
    '& code': { p: 0, backgroundColor: 'transparent' },
  },
  '& table': { my: 1.5, borderCollapse: 'collapse', width: '100%', display: 'block', overflowX: 'auto' },
  '& th, & td': { border: '1px solid rgba(0,0,0,0.12)', px: 1.25, py: 0.75, textAlign: 'left' },
  '& th': { backgroundColor: 'rgba(0,0,0,0.04)', fontWeight: 700 },
  '& img': { maxWidth: '100%' },
  '& hr': { my: 2, border: 0, borderTop: '1px solid rgba(0,0,0,0.12)' },
};

/**
 * Renderiza el cuerpo Markdown del comunicado.
 * Lo usan el modal del usuario y la vista previa del admin, para que la previa
 * sea idéntica a lo que verá el usuario.
 */
const AnnouncementMarkdown = ({ children, sx }) => (
  <Box sx={{ ...markdownSx, ...sx }}>
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
      {children || ''}
    </ReactMarkdown>
  </Box>
);

export default AnnouncementMarkdown;
